import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AcceptTermsAndConditionsPage } from './accept-terms-and-conditions.page';

const routes: Routes = [
  {
    path: '',
    component: AcceptTermsAndConditionsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AcceptTermsAndConditionsPageRoutingModule {}
